// /src/pages/Test.jsx
import React from 'react'

const Test = () => {
  return (
    <div className="min-h-screen bg-forest-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-lg">
        <h1 className="text-3xl font-bold text-forest-900 mb-4">Test Page</h1>
        <p className="text-forest-600 mb-4">If you can see this, routing is working!</p>
        <div className="space-y-2 text-sm">
          <p>✅ React is working</p>
          <p>✅ Routing is working</p>
          <p>✅ Styling is working</p>
        </div>
      </div>
    </div>
  )
}

export default Test 